import { render, staticRenderFns } from "./transition.vue?vue&type=template&id=810c9c90&scoped=true"
var script = {}
import style0 from "./transition.vue?vue&type=style&index=0&id=810c9c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810c9c90",
  null
  
)

export default component.exports